import LogOutputComposite from "./LogOutputComposite";
import levels from "./Levels";
import ConfigProvider from "./ConfigProvider";
import LogConsoleOut from "./LogConsoleOut";
import LogLocalStorageOut from "./LogLocalStorageOut";
import LogLogPanel from "./LogLogPanel";
import download from "downloadjs";

var logComposite = new LogOutputComposite();
var configProvider = new ConfigProvider();

const LoadConfig = () => {
  if (configProvider.GetConsole()) {
    EnableConsole();
  }
  if (configProvider.GetLocalStorageParam()) {
    EnableLocalStorageLogging();
  }
  if (configProvider.GetLocalStorageParam()) {
    EnableLogPanel();
  }
};

const GetInstance = () => {
  return window.log;
};

const SetLevel = (level) => {
  if (
    level === "FATAL" ||
    level === "ERROR" ||
    level === "WARN" ||
    level === "INFO" ||
    level === "DEBUG"
  ) {
    configProvider.SetLevel(level);
  }
};

const SetConsole = (bool) => {
  configProvider.SetConsole(bool);
  if (!!bool) logComposite.Register("Console", new LogConsoleOut());
  else logComposite.Unregister("Console");
};

const EnableConsole = () => {
  SetConsole(true);
};

const DisableConsole = () => {
  SetConsole(false);
};

const SetLocalStorageLogging = (bool) => {
  configProvider.SetLocalStorageParam(bool);
  if (!!bool) logComposite.Register("LocalStorage", new LogLocalStorageOut());
  else logComposite.Unregister("LocalStorage");
};

const EnableLocalStorageLogging = () => {
  SetLocalStorageLogging(true);
};

const DisableLocalStorageLogging = () => {
  SetLocalStorageLogging(false);
};

const SetLogPanelLogging = (bool) => {
  configProvider.SetLogPanelParam(bool);
  if (!!bool) logComposite.Register("LogPanel", new LogLogPanel());
  else logComposite.Unregister("LogPanel");
};

const EnableLogPanel = () => {
  SetLogPanelLogging(true);
};

const SetBufferSize = (number) => {
  if (Number.isInteger(number)) configProvider.SetBufferSize(number);
};

const SetLogSize = (number) => {
  if (Number.isInteger(number)) configProvider.SetLogSize(number);
};

const SetLogCount = (number) => {
  if (Number.isInteger(number)) configProvider.SetLogCount(number);
};

const FATAL = (msg) => {
  if (levels.FATAL <= configProvider.GetLevelValue()) {
    const message = BuildMessage(msg, "FATAL");
    logComposite.Save(message);
  }
};

const ERROR = (msg) => {
  if (levels["ERROR"] <= configProvider.GetLevelValue()) {
    const message = BuildMessage(msg, "ERROR");
    logComposite.Save(message);
  }
};

const WARN = (msg) => {
  if (levels["WARN"] <= configProvider.GetLevelValue()) {
    const message = BuildMessage(msg, "WARN");
    logComposite.Save(message);
  }
};

const INFO = (msg) => {
  if (levels["INFO"] <= configProvider.GetLevelValue()) {
    const message = BuildMessage(msg, "INFO");
    logComposite.Save(message);
  }
};

const DEBUG = (msg) => {
  if (levels["DEBUG"] <= configProvider.GetLevelValue()) {
    const message = BuildMessage(msg, "DEBUG");
    logComposite.Save(message);
  }
};

const BuildMessage = (msg, level) => {
  let message = `${GetDate()}  ${level} - ${msg}`;
  return message;
};

const GetDate = () => {
  const dateTime = new Date();
  return `${dateTime.getFullYear()}-${GetNumberWithZero(
    dateTime.getMonth() + 1
  )}-${GetNumberWithZero(dateTime.getDate())} ${GetNumberWithZero(
    dateTime.getHours()
  )}:${GetNumberWithZero(dateTime.getMinutes())}:${GetNumberWithZero(
    dateTime.getSeconds()
  )}.${GetNumberWithTwoZeros(dateTime.getMilliseconds())}`;
};

const GetNumberWithZero = (number) => {
  if (number < 10) return "0" + number;
  else return number;
};

const GetNumberWithTwoZeros = (number) => {
  if (number < 10) return "00" + number;
  else if (number < 100) return "0" + number;
  else return number;
};

const SaveLog = () => {
  const data = GetLogs();
  var blob = new Blob([data], { type: "text/plain" });
  download(blob, `CRM_${GetUsername()}_${GetDate()}.log`, "text/plain");
};

const GetUsername = () => {
  const sessionData = JSON.parse(sessionStorage.getItem("user"));
  return sessionData.username;
};

const GetLogs = () => {
  const logStatus = parseInt(localStorage.getItem("LogStatus"));
  let logData = "";
  let actualLogName = "";
  let log = "";

  if(!logStatus)
  {
    return "";
  }

  for (
    var i = IterateLogStatus(logStatus);
    i !== logStatus;
    i = IterateLogStatus(i)
  ) {
    actualLogName = `Log${i}`;
    log = localStorage.getItem(actualLogName);
    if (!!log) logData += log;
  }

  // add the newest log
  actualLogName = `Log${logStatus}`;
  log = localStorage.getItem(actualLogName);
  if (!!log) logData += log;

  // add logBuffer
  let logBuffer = localStorage.getItem("LogBuffer");
  if (!!logBuffer) logData += logBuffer;

  return logData;
};

const IterateLogStatus = (i) => {
  if (i === configProvider.GetLogCount()) i = 0;
  else i += 1;
  return i;
};

export default {
  LoadConfig,
  GetInstance,
  FATAL,
  ERROR,
  WARN,
  INFO,
  DEBUG,
  SetLevel,
  EnableConsole,
  DisableConsole,
  EnableLocalStorageLogging,
  DisableLocalStorageLogging,
  // EnableLogPanel,
  SetLogCount,
  SetLogSize,
  SetBufferSize,
  SaveLog,
  GetLogs,
};
